export default __webpack_public_path__ + "static/lookhere-a0cf07f401687bf9b6965f5862ce8db4.png";